module.exports = "/_next/static/images/01c08a8fe5c897ad8291ed7db5f5b87f-nu-card-md@3x.jpg";